import React, { useState, useEffect } from 'react';
import GeneralDataMobile from './generalDataMobile';
import GeneralDataWeb from './generalDataWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const GeneralDataRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? (
    <GeneralDataMobile {...props} />
  ) : (
    <GeneralDataWeb {...props} />
  );
};

export default GeneralDataRouter;
